'use strict';
/* eslint no-console: 0 */
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = validateEventLogAttempt;

var _eventPropTypes = require('event-tracking-tools/events/eventPropTypes');

var _eventPropTypes2 = _interopRequireDefault(_eventPropTypes);

var _utils = require('react-utils/utils');

var _ = require('_');

var _typeHelpers = require('event-tracking-tools/utils/typeHelpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NOPROP_MESSAGE = 'validateEventLogAttempt: all top-level record properties must have a matching entry in __propTypes__. Missing for';

function _loopAndValidateEventProps() {
  var propTypes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var useStrict = arguments[2];
  var record = arguments[3];
  var throwForNoPropTypes = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  var propTypeKeys = Object.keys(propTypes);

  propTypeKeys.forEach(function (key) {
    var value = propTypes[key];

    // If the value of the prop is a validator, use that one.
    if ((0, _.isFunction)(value)) {
      value(key, props[key], useStrict, record);

      // The default validator is (!null and !undefined)
    } else {
      _eventPropTypes2.default.REQUIRED(key, value, useStrict, record);
    }
  });

  if (throwForNoPropTypes) {
    props = (0, _.omit)(props, ['useStrict']);
    Object.keys(props).forEach(function (key) {
      var hasKey = propTypeKeys.indexOf(key) !== -1;
      if (useStrict) {
        (0, _utils.invariant)(hasKey, NOPROP_MESSAGE + ' \'%s\'', key);
      } else if (!hasKey) {
        console.warn(NOPROP_MESSAGE + ' \'' + key + '\'');
      }
    });
  }
}

function _validateEventRecordAndProps(record, props, useStrict) {
  record = record.toJS();
  useStrict = useStrict || record.useStrict;

  var recordPropTypes = record.__propTypes__;
  delete record.__propTypes__;

  var customPropTypes = record.propTypes;
  delete record.propTypes;

  _loopAndValidateEventProps(recordPropTypes, record, useStrict, record, true);
  _loopAndValidateEventProps(customPropTypes, props, useStrict, record);
}

function validateEventLogAttempt(record) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var useStrict = arguments[2];

  (0, _utils.invariant)((0, _typeHelpers.isObject)(props), 'validateEventLogAttempt: event props parameter sent through .log() must be undefined or an object. Got "%s"', props);
  _validateEventRecordAndProps(record, props, useStrict);
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/event-tracking-tools/static-1.15/js/events/validateEventLogAttempt.js
// module id = 538
// module chunks = 0